function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var r = [-2, -1, 0, 1, 2, 3, 4, 5],
  o = {
    "-2": {
      short: "TBD",
      full: "TBD"
    },
    "-1": {
      short: "PK",
      full: "Pre-kindergarten"
    },
    0: {
      short: "K",
      full: "Kindergarten"
    },
    1: {
      short: "G1",
      full: "Grade 1"
    },
    2: {
      short: "G2",
      full: "Grade 2"
    },
    3: {
      short: "G3",
      full: "Grade 3"
    },
    4: {
      short: "G4",
      full: "Grade 4"
    },
    5: {
      short: "G5",
      full: "Grade 5"
    }
  },
  a = {
    mg: {
      short: "MG",
      full: "Multigrade"
    },
    sen: {
      short: "SPED",
      full: "Special education"
    }
  },
  e = function e(s) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return Object.entries(o).filter(function (t) {
      return !d.includes(parseInt(t[0]));
    }).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        t = _ref2[0],
        l = _ref2[1];
      return {
        id: t,
        text: s === "short" ? l.short : l.full,
        value: parseInt(t)
      };
    }).sort(function (_ref3) {
      var t = _ref3.value;
      return t;
    });
  },
  p = e("short"),
  h = e("full"),
  G = e("short", [-2]),
  A = e("full", [-2]),
  i = r.filter(function (s) {
    return s !== -2;
  }),
  c = r,
  u = [].concat(r, ["mg", "sen"]),
  D = i.map(n),
  E = c.map(n),
  I = u.map(n);
function m(s) {
  return s in a;
}
function f(s) {
  return s in o;
}
function n(s) {
  if (f(s)) return _objectSpread({
    value: s
  }, o[s]);
  if (m(s)) return _objectSpread({
    value: s
  }, a[s]);
  throw new Error("Invalid grade value: ".concat(s));
}
var S = {
    email: "support@happynumbers.com"
  },
  T = {
    email: "cs@happynumbers.com"
  },
  _ = {
    en: "English",
    es: "Spanish"
  },
  g = {
    primary: "Placement",
    middle: "Mid-Year",
    finally: "End-of-Year"
  },
  w = {
    primary: "PT",
    middle: "MOY",
    finally: "EOY"
  },
  B = {
    far_below: "Far below",
    below: "Below",
    meets: "Meets",
    exceeds: "Exceeds",
    tbd: "TBD"
  };
export { D as GRADES, E as GRADES_WITH_TBD, I as GRADES_WITH_VARIANTS, i as GRADE_VALUES, c as GRADE_VALUES_WITH_TBD, u as GRADE_VALUES_WITH_VARIANTS, o as Grades, g as LabelsByAssessment, B as LabelsByAssessmentResult, _ as Languages, w as ShortLabelsByAssessment, a as VariantGrades, T as cs, h as dropdownItemsFull, A as dropdownItemsNoTBDFull, G as dropdownItemsNoTBDShort, p as dropdownItemsShort, n as getGradeData, f as isValidGrade, m as isValidVariantGrade, S as support, r as values };